import React from 'react';
import { Loader } from '@/components/common/Loader';
import { lazyComponent } from '@/components/common/utils/lazyImport';
import { useTranslations } from '@/core/translations';
import { BasePanel } from '@/components/composite/GeoMap/panels';

export const LazyMapViewPanel = lazyComponent(() => import(/* webpackChunkName: 'FiltersPanel' */ './MapViewPanel'), {
  preload: true,
  loading: () => {
    const t = useTranslations();
    return (
      <BasePanel title={t('incidents_page.map_view')} onClickClose={() => null}>
        <Loader />
      </BasePanel>
    );
  },
});
